import { all, call } from 'redux-saga/effects';

import { requestSagas } from './request/request.sagas';
import { deactivateSagas } from './deactivate/deactivate.sagas';
import { rejectRequestSagas } from './reject-request/reject-request.sagas';

export default function* rootSaga() {
    yield all([
        call(requestSagas),
        call(deactivateSagas),
        call(rejectRequestSagas),
    ]);
}
